export default {
  name: {
    '158.Agribank': 'UCN argibank',
  },

  Validate: {
    Title: 'Không hợp lệ',
    ChooseBudgetItemCode: 'Bạn chưa chọn Mục. Xin vui lòng chọn lại.',
    ChooseBudgetItemAndSubItemCode: 'Bạn chưa chọn &ltMục/Tiểu mục&gt;! Xin vui lòng chọn lại.',
    ChangeDataMessgeShowHideReport: 'Dữ liệu đã thay đổi, bạn có muốn cất không?',
    ChangeDataMessgeTitleShowHideReport: 'Ẩn hiện báo cáo',
  },

  ReportEdit: {
    Title: 'Sửa mẫu {0}',
    TabSetting: 'Thiết kế',
    TabCustom: 'Nội dung',
    SettingBackground: 'Chọn hình nền',
    SettingBackgroundLabel: 'Chọn hình nền',
    SettingBackgroundNone: 'Không chọn',
    SettingBackgroundBrowser: 'Tải hình từ máy tính',
    SettingBackgroundPosition: 'Vị trí',
    SettingBackgroundPositionCenter: 'Giữa chứng từ',
    SettingBackgroundPositionFull: 'Toàn chứng từ',
    SettingBackgroundOpacity: 'Độ nét (%)',
    SettingLogo: 'Chọn logo',
    SettingLogoBrowser: 'Tải lên ảnh mới',
    SettingLogoRemove: 'Xóa',
    SettingLogoPosition: 'Vị trí',
    SettingLogoPositionLeft: 'Trái',
    SettingLogoPositionCenter: 'Giữa',
    SettingLogoPositionRight: 'Phải',
    SettingLogoSize: 'Kích thước',
    SettingFontColor: 'Chọn màu chữ',
    SettingFont: 'Font chữ',
    SettingMargin: 'Căn lề',
    SettingMarginTop: 'Căn lề trên',
    SettingMarginLeft: 'Căn lề trái',
    SettingMarginBottom: 'Căn lề dưới',
    SettingMarginRight: 'Căn lề phải',
    SettingMarginReset: 'Lấy lại mặc định',
    SettingHeighEsign: 'Chiều cao phần chữ ký',
    SettingSign: 'Sửa chân chữ ký',
    CustomEmpty: 'Bấm vào bút chì bên phải để chỉnh sửa từng phần',
    CustomEditable: 'Bấm vào từng nhóm để tinh chỉnh',
    ViewPdfButton: 'Xem PDF',
    DefaultButton: 'Lấy mẫu mặc định',
    DefaultTemplate: 'Lấy lại mẫu mặc định',
    SaveButton: 'Cất',
    SaveAndCloseButton: 'Cất và Đóng',
    AddExtField: 'Thêm thông tin bổ sung',
    SettingPage: 'Thay đổi mẫu',
    PageInvoiceType: 'Loại hóa đơn',
    PageInvoiceName: 'Tên mẫu hóa đơn',
    PageInvoiceNo: 'Mẫu số',
    PageInvoiceSymbol: 'Ký hiệu',
    SaveSuccess: 'Cất mẫu thành công.',
    ResetDefaultSuccess: 'Sử dụng mẫu ngầm định của chương trình.',
    ConfirmEditClose: 'Mẫu đã có thay đổi, bạn có muốn cất trước khi đóng không?',
    UploadNewImage: 'Tải lên ảnh mới',
    Remove: 'Xóa',
    ImageValidationMessage: 'Dung lượng tối đa 1MB, độ rộng tối thiểu 150px, định dạng jpg, jpeg, png',
    LabelName: 'Tên nhãn dữ liệu',
    LabelNameUI: 'Tên nhãn trên giao diện',
    LabelNameSign: 'Tên chức danh',
    LabelNameValueSign: 'Tên người ký',
    DataColumnHeader: 'Tên cột dữ liệu',
    DisplayedDataColumnHeader: 'Tên cột trên giao diện',
    EmptyRow: 'Dòng trống',
    WatchInstructionHere: 'Xem video hướng dẫn',
    HowToEditTemplate: 'Hướng dẫn sửa mẫu',
    Uppercase: 'In hoa',
    Formular: 'Công thức',
    NameField: 'Tên cột trên bảng',
    GuideLine: 'Nhấn đúp để chọn dòng trong danh sách vào công thức',
    SourceField: 'Tên trường dữ liệu',
    IsSummary: 'Tính tổng',
    SayMoney: 'Đọc số tiền bằng chữ',
    DefaultValue: 'Để trống khi = 0',
    CheckFormular: 'Kiểm tra',
    SummaryDetail: 'Tổng cột',
    FormatType: 'Định dạng theo',
    Delete: 'Xóa',
    InfoSetupFormula: 'Nhấn để chọn dòng trong danh sách vào công thức',
    SetupFormula: 'Thiết lập công thức',
    SetupSum: 'Thiết lập tổng',
    SumDetail: 'Tổng cột',
    TutorialVideo: 'Hướng dẫn sửa mẫu',
  },
};
